import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import Keycloak from 'keycloak-js';
import { selectUser, selectUserState } from '../../core/state/user/user.selectors';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private keycloak = inject(Keycloak);

  constructor(private router: Router, private store: Store) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const isLoggedIn = this.keycloak.authenticated ?? false;

    // With 'login-required' in provideKeycloak, Keycloak automatically handles login
    // If user reaches here and is not logged in, something went wrong
    if (!isLoggedIn) {
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url
      });
      return false;
    }

    const token = this.keycloak.tokenParsed;

    if(route.data.role){
      if(token?.resource_access?.[environment.clientId]?.roles.includes(route.data.role) === false){
        this.router.navigate(['/unauthorized']);
        return false;
      }
    }

    return true;
  }
}
